<div class="title mb-4">
  <h2>Forum Giveaway</h2>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="white_box shadow p-3">
      <div class="btn-group mb-3">
        <button [routerLink]="['/admin/forum-polling']" class="btn btn-light">Polling</button>
        <button [routerLink]="['/admin/forum-giveaway']" class="btn btn-primary">Giveaway</button>
      </div>
      <form>
        <div class="mb-3 row">
          <!-- <label for="table-filtering-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label> -->
          <div class="col-xs-3 col-sm-auto">
            <button type="button" (click)="openForm(giveawayForm)" class="btn btn-success btn-sm mb-2"><i class="fa-solid fa-plus"></i> Create</button>
          </div>
          <!-- <div class="col-xs-3 col-sm-auto">
            <input id="table-filtering-search" class="form-control" type="text" placeholder="Search"
              [formControl]="filter" />
          </div> -->
        </div>
      </form>

      <!-- Table -->
      <section>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Image</th>
              <th scope="col">Title</th>
              <th scope="col">End Date</th>
              <th scope="col">Sub Region</th>
              <th scope="col">Allow Auto Participate</th>
              <th scope="col">Participants</th>
              <th scope="col">Ended?</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of giveaways?.data; index as i">
              <tr>
                <th scope="row">{{ i + 1 }}</th>
                <td>
                  <img loading="lazy" *ngFor="let image of item?.images" src="{{ image.filePreview }}" class="img-thumbnail mr-2" style="height: 50px" alt="" />
                </td>
                <td>{{ item?.title }}</td>
                <td>{{ item?.endDate || "Limit Participant" }}</td>
                <td>{{ item?.subRegionName != "" ? item.subRegionName : "All" }}</td>
                <td>{{ item?.allowAutoParticipate ? "Active" : "Disable" }}</td>
                <td>
                  <button class="btn btn-success" (click)="showParticipant(giveawayParticipant, item)">{{ item.giveaway_participants.length }}/{{ item.participantLimit }}</button>
                </td>
                <td>
                  <span *ngIf="!item.isEnded" class="badge badge-success">Running</span>
                  <span *ngIf="item.isEnded" class="badge badge-danger">Ended</span>
                </td>
                <td>
                  <div class="btn-group">
                    <button class="btn btn-sm btn-warning" (click)="openForm(giveawayForm, item)"><i class="fa-solid fa-edit"></i> Edit</button>
                    <button class="btn btn-sm btn-danger" (click)="deleteGiveaway(item.id)"><i class="fa-solid fa-trash"></i> Delete</button>
                    <!-- <button class="btn btn-sm btn-success" [routerLink]="['/admin/forum-giveaway', item.id]">
                      <i class="fa-solid fa-tasks"></i> Survey
                    </button> -->
                  </div>
                </td>
              </tr>
            </ng-container>

            <!-- <tr>
																	<td colspan="4" style="text-align: center">No countries found</td>
															</tr> -->
          </tbody>
        </table>
      </section>
      <!-- Table -->
    </div>
  </div>
</div>

<ng-template #giveawayForm let-modal>
  <div id="poll_form_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <form (submit)="storeGiveaway()">
      <div class="modal-body">
        <h5 class="text-center">Create New Giveaway</h5>
        <div class="form-group">
          <label for="">Title</label>
          <input type="text" [(ngModel)]="giveaway.title" [ngModelOptions]="{ standalone: true }" class="form-control" />
        </div>
        <div class="form-group">
          <label for="">Description</label>
          <app-editor [(innerValue)]="giveaway.description"></app-editor>
        </div>
        <div class="form-group">
          <label for="">Sub Region</label> {{ giveaway.subRegionName }}
          <select class="form-control" [(ngModel)]="giveaway.subRegion" [ngModelOptions]="{ standalone: true }">
            <option value="0" selected>All</option>
            <option [value]="item.subRegionId" *ngFor="let item of subRegions">{{ item.name }}</option>
          </select>
        </div>
        <div class="row">
          <div class="form-group col-sm-6" *ngIf="!giveaway.endWhenParticipantReached">
            <label for="">End Date and Time</label>
            <input type="datetime-local" [(ngModel)]="giveaway.startDate" [ngModelOptions]="{ standalone: true }" class="form-control" />
          </div>
          <div class="form-group col-sm-6" *ngIf="!giveaway.endWhenParticipantReached">
            <label for="">End Date and Time</label>
            <input type="datetime-local" [(ngModel)]="giveaway.endDate" [ngModelOptions]="{ standalone: true }" class="form-control" />
          </div>
          <div class="form-group col-sm-12">
            <input type="checkbox" id="endWhenParticipantReached" [(ngModel)]="giveaway.endWhenParticipantReached" [ngModelOptions]="{ standalone: true }" />
            <label for="endWhenParticipantReached">&nbsp; End when participant reached?</label>
          </div>
          <div class="form-group col-sm-12">
            <input type="checkbox" id="onlyVerified" [(ngModel)]="giveaway.onlyVerified" [ngModelOptions]="{ standalone: true }" />
            <label for="onlyVerified">&nbsp; Only Verified Participants?</label>
          </div>
          <div class="form-group col-sm-4">
            <label for="">Status</label>
            <select class="form-control" [(ngModel)]="giveaway.status" [ngModelOptions]="{ standalone: true }">
              <option [value]="true">Active</option>
              <option [value]="false">Disable</option>
            </select>
          </div>
          <div class="form-group col-sm-4">
            <label for="">Allow Auto Participate</label>
            <select class="form-control" [(ngModel)]="giveaway.allowAutoParticipate" [ngModelOptions]="{ standalone: true }">
              <option [value]="true">Active</option>
              <option [value]="false">Disable</option>
            </select>
          </div>
          <div class="form-group col-sm-4">
            <label for="">Participant Limit</label>
            <select class="form-control" [(ngModel)]="giveaway.participantLimit" [ngModelOptions]="{ standalone: true }">
              <option [value]="100">100</option>
              <option [value]="1000">1000</option>
              <option [value]="10000">10000</option>
            </select>
          </div>
        </div>
        <div class="d-flex" *ngFor="let image of giveaway.images; let i = index">
          <img loading="lazy" src="{{ image.filePreview }}" class="img-thumbnail mr-2" style="height: 80px" alt="" />
          <div class="form-group w-100">
            <label for="">Image {{ i + 1 }}</label>
            <div class="d-flex">
              <input type="file" class="form-control" (change)="onImageChange($event, image)" [ngModelOptions]="{ standalone: true }" />
              <button type="button" class="btn btn-danger btn-sm ml-2" (click)="removeImage(i)">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <button class="btn btn-primary mt-2" type="button" (click)="handleAddImage()"><i class="fa-solid fa-plus"></i> Add File</button>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger mr-2" [disabled]="poll?.hasSubmit" (click)="modalService.dismissAll()"><i class="fa-solid fa-times"></i> Cancel</button>
        <button class="btn btn-primary" type="submit" [disabled]="poll?.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Submit</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #giveawayParticipant let-modal>
  <div id="poll_form_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-header">
      <h6>Giveaway - {{ giveaway.title }}</h6>
    </div>
    <div class="modal-body">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Participant Name</th>
            <th scope="col">Phone</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let participant of giveaway.giveaway_participants; let i = index">
            <th scope="row">{{ i + 1 }}</th>
            <td>{{ participant?.appUser?.profileCharacterName }}</td>
            <td>
              {{ participant?.appUser?.phone }}
              <span class="badge badge-success" *ngIf="participant.isWinner">Winner</span>
            </td>
            <td>
              <div *ngIf="participant.isWinner">
                <button class="btn btn-success btn-sm" (click)="sendNotifyMail(participant.userId)">Send Notification</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger mr-2" (click)="modalService.dismissAll()"><i class="fa-solid fa-times"></i> Cancel</button>
    </div>
  </div>
</ng-template>
